var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbubbleTyping = function SvgChatbubbleTyping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.934 3.829.008.004.008.004a9.068 9.068 0 0 1-7.72 16.41l-.546-.256-4.146.747 1.207-3.215-.483-.787A9.069 9.069 0 0 1 15.934 3.829M2.65 17.723l-1.565 4.168a.788.788 0 0 0 .876 1.052l5.464-.985a10.958 10.958 0 0 0 9.329-19.831A10.959 10.959 0 0 0 2.65 17.723m5.731-4.61a1.576 1.576 0 1 1-2.228-2.229 1.576 1.576 0 0 1 2.228 2.228m4.728 0a1.576 1.576 0 1 0-2.228-2.23 1.576 1.576 0 0 0 2.228 2.23m4.728 0a1.576 1.576 0 1 0-2.229-2.23 1.576 1.576 0 0 0 2.229 2.23",
    clipRule: "evenodd"
  })));
};
export default SvgChatbubbleTyping;